import { atom } from 'recoil';

// Interfaces para os dados de análise de currículo
export interface CurriculoBasics {
  name: string;
  email: string;
  phone: string;
  website?: string;
  location?: {
    address: string;
  };
}

export interface CurriculoEducation {
  institution: string;
  location?: string;
  area: string;
  studyType: string;
  startDate: string;
  endDate: string;
}

export interface CurriculoWork {
  company: string;
  location?: string;
  position: string;
  startDate: string;
  endDate: string;
  highlights: string[];
}

export interface CurriculoSkill {
  name: string;
  keywords: string[];
}

export interface CurriculoHeadings {
  education?: string;
  skills?: string;
  work?: string;
  qualifications?: string;
  projects?: string;
}

export interface CurriculoAnalysisResult {
  headings?: CurriculoHeadings;
  basics?: CurriculoBasics;
  education?: CurriculoEducation[];
  work?: CurriculoWork[];
  skills?: CurriculoSkill[];
  projects?: any[];
  qualifications?: any[];
  sections?: string[];
}

export interface SugestaoMelhoria {
  tipo: 'Conteúdo' | 'Estrutura' | 'Gramática' | 'Formato' | 'Erro';
  titulo: string;
  descricao: string;
  exemploMelhoria: string;
  prioridade: number; // 1-5, sendo 1=baixa e 5=alta
}

export interface SugestoesMelhoriaResponse {
  secao: string;
  caminhoCampo: string | null;
  descricaoCampo: string;
  valorAtual: string | null;
  sugestoes: SugestaoMelhoria[];
  resumoAnalise: string;
  pontuacaoGeral: number;
}

export interface ImportarCurriculoRequest {
  cvFile: File;
  contexto?: string;
  mercadoAlvo?: string;
}

export interface CurriculoHistoryItem {
  id: number;
  idContato: number;
  descricao: string;
  curriculoData: any;
  dtCadastro: string;
  dtAtualizacao: string;
  ativo: boolean;
}

export interface SaveHistoryRequest {
  idContato: number;
  descricao: string;
  curriculoData: any;
}

// Request para análise de seção completa
export interface SugestoesMelhoriaSecaoRequest {
  secao:
    | 'basics'
    | 'education'
    | 'work'
    | 'skills'
    | 'projects'
    | 'qualifications'
    | 'headings'
    | 'sections';
  caminhoCampo?: null;
  valorAtual?: null;
  dadosCurriculo: CurriculoAnalysisResult;
  contatoId: number;
}

// Request para análise de campo específico
export interface SugestoesMelhoriaCampoRequest {
  secao:
    | 'basics'
    | 'education'
    | 'work'
    | 'skills'
    | 'projects'
    | 'qualifications'
    | 'headings'
    | 'sections';
  caminhoCampo: string; // ex: work[0].highlights[1]
  valorAtual?: string;
  dadosCurriculo: CurriculoAnalysisResult;
  contatoId: number;
}

export const curriculoAnalysisAtom = atom<CurriculoAnalysisResult | null>({
  key: 'curriculoAnalysis_v2',
  default: null,
});

export const curriculoSuggestionsAtom = atom<SugestoesMelhoriaResponse | null>({
  key: 'curriculoSuggestions_v2',
  default: null,
});

export const curriculoLoadingAtom = atom<boolean>({
  key: 'curriculoLoading_v2',
  default: false,
});

export const curriculoProcessingAtom = atom<boolean>({
  key: 'curriculoProcessing_v2',
  default: false,
});
